import { injectReducer } from '../../store/reducers'

export default (store) => ({
  path : 'customer',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const CustomerList = require('./containers/CustomersContainer').default
      const reducer = require('../../store/customer').default
      // const CartReducer = require('../../store/cart')

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, { key: 'customer', reducer })

      /*  Return getComponent   */
      cb(null, CustomerList)

    /* Webpack named bundle   */
    }, 'customerList')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CustomerList/index.js